/* DecantGems sample set builder (sections/dg-set-builder.liquid).
   The list of samples is rendered by Shopify; this script keeps the visitor's choice (sessionStorage), draws the
   tray (chips, counter, plain sum), loads further pages or another collection through the Section Rendering API
   and adds the chosen samples to the cart in ONE request to /cart/add.js. No discount logic of any kind.
   Only variants that the server rendered as purchasable (price above 0 and stock) can be chosen. */
import { CartLinesUpdateEvent } from '@shopify/events';
import { flyToCart, notifyCart } from '@dg/fly';

(function () {
  'use strict';
  var KEY = 'dg-set:1';
  var MAX_AUTO_PAGES = 5;

  function init(root) {
    var mode = root.getAttribute('data-mode') || 'builder';
    var list = root.querySelector('[data-setb-list]');
    var tray = root.querySelector('[data-setb-tray]');
    if (!list || !tray) return;
    var T = {};
    try { T = JSON.parse(root.querySelector('[data-setb-t]').textContent); } catch (e) {}
    var slots = tray.querySelector('[data-setb-slots]');
    var counter = tray.querySelector('[data-setb-counter]');
    var totalWrap = tray.querySelector('[data-setb-total-wrap]');
    var total = tray.querySelector('[data-setb-total]');
    var go = tray.querySelector('[data-setb-go]');
    var clear = tray.querySelector('[data-setb-clear]');
    var status = tray.querySelector('[data-setb-status]');
    var moreWrap = root.querySelector('[data-setb-more-wrap]');
    var none = root.querySelector('[data-setb-none]');
    var plain = root.querySelector('[data-setb-plain]');
    var controls = root.querySelector('[data-setb-controls]');
    var src = root.getAttribute('data-src') || 'all-samples';
    var home = src;
    var collectionsUrl = (root.getAttribute('data-collections') || '/collections').replace(/\/$/, '');
    var busy = false;
    var state = { n: parseInt(root.getAttribute('data-default'), 10) || 5, items: [] };

    function money(cents) {
      try {
        return new Intl.NumberFormat(root.getAttribute('data-locale') || 'en', { style: 'currency', currency: root.getAttribute('data-currency') || 'EUR' }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    }
    function save() {
      if (mode !== 'builder') return;
      try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    }
    function load() {
      if (mode !== 'builder') return;
      try {
        var s = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (s && Array.isArray(s.items)) {
          state.items = s.items.filter(function (i) { return i && /^\d+$/.test(String(i.pid)) && /^\d+$/.test(String(i.vid)); }).slice(0, 12);
          if (s.n >= 2 && s.n <= 12) state.n = s.n;
        }
      } catch (e) {}
    }
    function say(text) { if (status) status.textContent = text || ''; }
    function find(pid) {
      for (var i = 0; i < state.items.length; i++) if (String(state.items[i].pid) === String(pid)) return i;
      return -1;
    }
    function cards() { return Array.prototype.slice.call(list.querySelectorAll('[data-setb-item]')); }
    function nextPage() {
      var el = list.querySelectorAll('[data-setb-next]');
      el = el[el.length - 1];
      return el ? parseInt(el.getAttribute('data-setb-next'), 10) || 0 : 0;
    }
    function itemOf(card) {
      var sel = card.querySelector('[data-setb-variant]');
      var vid = card.getAttribute('data-vid'), size = card.getAttribute('data-size'), cents = parseInt(card.getAttribute('data-cents'), 10) || 0;
      if (sel && sel.selectedOptions[0]) {
        vid = sel.value; size = sel.selectedOptions[0].getAttribute('data-size'); cents = parseInt(sel.selectedOptions[0].getAttribute('data-cents'), 10) || 0;
      }
      return { pid: card.getAttribute('data-pid'), vid: vid, title: card.getAttribute('data-title') || '', size: size || '', cents: cents };
    }

    function render() {
      var n = mode === 'set' ? Math.max(cards().length, state.items.length) : state.n;
      cards().forEach(function (card) {
        var on = find(card.getAttribute('data-pid')) > -1;
        var btn = card.querySelector('[data-setb-pick]');
        if (!btn) return;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', btn.getAttribute(on ? 'data-label-remove' : 'data-label-add'));
      });
      slots.textContent = '';
      state.items.forEach(function (item) {
        var li = document.createElement('li'); li.className = 'dg-setb__slot';
        var span = document.createElement('span'); span.textContent = item.title + (item.size ? ' · ' + item.size : '');
        var b = document.createElement('button'); b.type = 'button'; b.textContent = '×';
        b.setAttribute('aria-label', (T.remove || 'Remove [title]').replace('[title]', item.title));
        b.addEventListener('click', function () { toggle(item.pid, null); });
        li.appendChild(span); li.appendChild(b); slots.appendChild(li);
      });
      if (mode === 'builder') {
        for (var i = state.items.length; i < n; i++) {
          var e = document.createElement('li'); e.className = 'dg-setb__slot dg-setb__slot--empty'; e.textContent = T.empty || '';
          slots.appendChild(e);
        }
      }
      var have = state.items.length;
      counter.textContent = (T.counter || '[n] / [t]').replace('[n]', have).replace('[t]', n);
      var sum = state.items.reduce(function (a, i) { return a + (i.cents || 0); }, 0);
      total.textContent = money(sum);
      totalWrap.hidden = !(have > 0 && sum > 0);
      go.disabled = have === 0 || busy;
      if (clear) clear.hidden = have === 0 || mode !== 'builder';
      tray.hidden = !(have > 0 || (mode === 'set' && cards().length > 0));
      root.querySelectorAll('[data-setb-size]').forEach(function (r) { r.checked = parseInt(r.value, 10) === state.n; });
    }

    function toggle(pid, card) {
      var at = find(pid);
      say('');
      if (at > -1) state.items.splice(at, 1);
      else if (card) {
        if (mode === 'builder' && state.items.length >= state.n) { say(T.full); return; }
        state.items.push(itemOf(card));
      }
      save(); render();
      if (mode === 'builder' && state.items.length > 0 && state.items.length < state.n) {
        say((T.need || '').replace('[n]', state.n - state.items.length));
      }
    }

    function showEmptyState() {
      var have = cards().length;
      list.hidden = have === 0;
      var sizesEl = root.querySelector('[data-setb-sizes]');
      var hasFilter = !!root.querySelector('[data-setb-src]');
      if (sizesEl) sizesEl.hidden = have === 0;
      if (controls) controls.hidden = have === 0 && !(hasFilter && src !== home);
      if (none) none.hidden = have > 0;
      if (plain) plain.hidden = have > 0 && mode === 'builder';
      if (moreWrap) moreWrap.hidden = !(have > 0 && nextPage() > 0);
    }

    function fetchPage(handle, page) {
      var url = collectionsUrl + '/' + encodeURIComponent(handle) + '?page=' + page + '&section_id=dg-set-builder';
      return fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var got = doc.querySelector('[data-setb-list]');
        return got ? Array.prototype.slice.call(got.children) : [];
      });
    }
    function append(nodes) {
      nodes.forEach(function (node) {
        if (node.hasAttribute('data-setb-item') && list.querySelector('[data-setb-item][data-pid="' + node.getAttribute('data-pid') + '"]')) return;
        list.appendChild(document.importNode(node, true));
      });
    }
    /* load pages until there is something to choose from (or the collection ends); auto = the first fill.
       gen: a source switch drops every answer still on its way (code-js-07: a late page of the old source was
       appended to the new list and page 2 of the new one was skipped); loading: no second "more" while one loads. */
    var more = root.querySelector('[data-setb-more]');
    var gen = 0;
    var loading = false;
    function settle() { loading = false; list.removeAttribute('aria-busy'); if (more) more.disabled = false; showEmptyState(); render(); }
    function fill(auto, pagesLeft, g) {
      if (g === undefined) g = gen;
      if (g !== gen) return Promise.resolve();
      var page = nextPage();
      if (!page || pagesLeft <= 0) { settle(); return Promise.resolve(); }
      loading = true;
      list.setAttribute('aria-busy', 'true');
      if (more) more.disabled = true;
      return fetchPage(src, page).then(function (nodes) {
        if (g !== gen) return;
        append(nodes);
        if (auto && cards().length < 10) return fill(true, pagesLeft - 1, g);
        settle();
      }).catch(function () { if (g !== gen) return; settle(); });
    }
    function switchTo(handle) {
      if (!/^[a-z0-9][a-z0-9-]*$/.test(handle)) return Promise.resolve();
      gen++;
      src = handle;
      list.textContent = '';
      var marker = document.createElement('li'); marker.hidden = true; marker.setAttribute('data-setb-next', '1');
      list.appendChild(marker);
      list.hidden = false;
      root.querySelectorAll('[data-setb-src]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-setb-src') === handle ? 'true' : 'false'); });
      return fill(true, MAX_AUTO_PAGES);
    }

    list.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-setb-pick]');
      if (!btn) return;
      var card = btn.closest('[data-setb-item]');
      if (card) toggle(card.getAttribute('data-pid'), card);
    });
    list.addEventListener('change', function (event) {
      var sel = event.target.closest && event.target.closest('[data-setb-variant]');
      if (!sel) return;
      var card = sel.closest('[data-setb-item]');
      var at = card ? find(card.getAttribute('data-pid')) : -1;
      if (at > -1) { state.items[at] = itemOf(card); save(); render(); }
    });
    root.querySelectorAll('[data-setb-size]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        state.n = parseInt(radio.value, 10) || state.n;
        if (state.items.length > state.n) state.items = state.items.slice(0, state.n);
        say(''); save(); render();
      });
    });
    root.querySelectorAll('[data-setb-src]').forEach(function (btn) {
      btn.addEventListener('click', function () { switchTo(btn.getAttribute('data-setb-src')); });
    });
    if (more) more.addEventListener('click', function () { if (!loading) fill(false, 1); });
    if (clear) clear.addEventListener('click', function () { state.items = []; say(''); save(); render(); });

    go.addEventListener('click', function () {
      if (busy || !state.items.length) return;
      busy = true; go.disabled = true; go.textContent = T.adding || go.textContent; say('');
      var body = { items: state.items.map(function (i) { return { id: parseInt(i.vid, 10), quantity: 1 }; }) };
      /* vd-05: with a cart drawer on the page the set goes in without leaving it (Horizon section rendering) */
      var drawer = document.getElementById('cart-drawer');
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
      if (drawer && ids.length) body.sections = ids.join(',');
      fetch(root.getAttribute('data-add') || '/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        /* code-js-08: Shopify names the sample that blocks the set ("… is uitverkocht"); show that, not a generic error */
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) { var e = new Error(j.description || j.message || ('HTTP ' + r.status)); e.status = r.status; e.shop = !!(j.description || j.message); throw e; }
          return j;
        });
      }).then(function (added) {
        say(T.done);
        if (mode === 'builder') { state.items = []; save(); }
        if (!drawer || !ids.length || typeof drawer.open !== 'function') {
          /* cart as a page (owner, 16 Oct): stay here, the chosen photos fly to the cart icon one after another (assets/dg-fly.js) */
          var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-setb-slots] img'));
          if (!imgs.length) imgs = cards().filter(function (c) { return mode === 'set' || c.querySelector('[aria-pressed="true"]'); })
            .map(function (c) { return c.querySelector('img'); }).filter(Boolean);
          var flights = imgs.slice(0, 5).map(function (img, k) {
            var src = img.currentSrc || img.src;
            return flyToCart(src ? { src: src, rect: (img.getBoundingClientRect().width > 4 ? img : go).getBoundingClientRect() } : null, k * 90);
          });
          return notifyCart('dg-set-builder', body.items.map(function (i) { return { merchandiseId: String(i.id), quantity: 1 }; }), Promise.all(flights))
            .then(function () { busy = false; go.textContent = T.add_all || go.textContent; render(); })
            .catch(function () { window.location.href = root.getAttribute('data-cart') || '/cart'; });
        }
        return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          var d = CartLinesUpdateEvent.createPromise();
          go.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: body.items.map(function (i) { return { merchandiseId: String(i.id), quantity: 1 }; }), promise: d.promise }));
          d.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, itemCount: body.items.length, source: 'dg-set-builder', sections: added && added.sections, didError: false } });
          if (!drawer.hasAttribute('open')) drawer.open();
          busy = false; go.textContent = T.add_all || go.textContent; render();
        }).catch(function () { window.location.href = root.getAttribute('data-cart') || '/cart'; });
      }).catch(function (err) {
        busy = false; go.textContent = T.add_all || go.textContent;
        say(err && err.shop && err.status === 422 ? err.message + ' ' + (T.blocked || '') : T.error);
        render();
      });
    });

    load();
    if (mode === 'set') {
      state.items = cards().map(itemOf);
    } else {
      /* a choice that points at a sample which is no longer offered here is kept: the cart request is the judge */
      var from = '';
      try { from = new URL(window.location.href).searchParams.get('from') || ''; } catch (e) {}
      if (from && from !== src && /^[a-z0-9][a-z0-9-]*$/.test(from)) { render(); switchTo(from); return; }
    }
    render();
    if (mode === 'builder' && cards().length < 10 && nextPage() > 0) fill(true, MAX_AUTO_PAGES);
    else showEmptyState();
  }

  function boot() { document.querySelectorAll('[data-dg-setb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
